// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./telemetry-modal-header.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

body {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

h2 {
    font-size: 1.5rem;
    font-weight: bold;
}

p {
    font-size: 1rem;
    line-height: 1.5em;
}

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

/* from scratch-www */

.telemetry-modal_modal-overlay_eJjcx {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 510;
    background-color: var(--ui-modal-overlay);
}

.telemetry-modal_modal-content_vTkMr {
    margin: 100px auto;
    outline: none;
    border: .25rem solid var(--ui-white-transparent);
    padding: 0;
    border-radius: 0.5rem;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    width: 640px;

    color: var(--text-primary);
    overflow: hidden;
}

.telemetry-modal_illustration_ZM4Wu {
    width: 100%;
    height: 123px;
    background-color: var(--looks-secondary);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
}

.telemetry-modal_body_Xq3Cm {
    background: var(--ui-white);
    padding: 1.5rem 2.25rem;
}

.telemetry-modal_privacy-policy-link_UYBzF {
    color: var(--looks-secondary);
    text-decoration: none;
}

/* stack the radio buttons vertically, not horizontally */

.telemetry-modal_radio-buttons_WNQTW label {
    display: block;
    margin: 0.5rem;
    transition: all .125s ease;
    background-color: hsla(0, 0%, 95%, 1);
    border-radius: .5rem;
    margin: 0 auto 0.375rem;
    align-items: center;
    padding: 1rem 0;
    vertical-align: middle;
}

.telemetry-modal_radio-buttons_WNQTW label:hover {
    background-color: hsla(215, 100%, 65%, .1);
}

.telemetry-modal_radio-buttons_WNQTW label.telemetry-modal_label-selected_osqYm,
.telemetry-modal_radio-buttons_WNQTW label.telemetry-modal_label-selected_osqYm:hover {
    background-color: hsla(215, 100%, 65%, .25);
}

.telemetry-modal_radio-buttons_WNQTW input[type="radio"] {
    margin: -1px 0.75rem 1px;
    border: 1px solid hsla(0, 0%, 0%, .1);
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    background-color: var(--ui-white);
    vertical-align: middle;
}

.telemetry-modal_radio-buttons_WNQTW input[type="radio"]:checked,
.telemetry-modal_radio-buttons_WNQTW input[type="radio"]:focus {
    box-shadow: 0 0 0 2px hsla(215, 100%, 65%, .25);
    outline: none;
}

.telemetry-modal_radio-buttons_WNQTW input[type="radio"]:checked {
    transition: all .25s ease;
    background-color: var(--ui-white);
    border: 1px solid var(--looks-secondary);
}

.telemetry-modal_radio-buttons_WNQTW input[type="radio"]:checked::after {
    display: block;
    margin: 0.125rem;
    border-radius: 50%;
    background-color: var(--looks-secondary);
    width: .625rem;
    height: .625rem;
    content: "";
}

/* Confirmation buttons at the bottom of the modal */

.telemetry-modal_button-row_pc6a2 {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: baseline;

    margin: 1.5rem 0;
    font-weight: bolder;
}

@keyframes telemetry-modal_fade-out_xVg3i {
    0% {opacity: 1}
    100% {opacity: 0}
}

.telemetry-modal_setting-was-updated_dQbap {
    animation: telemetry-modal_fade-out_xVg3i 3s ease-out;
    color: var(--extensions-primary);
}

.telemetry-modal_button-row_pc6a2 button {
    border: 1px solid var(--looks-secondary);
    border-radius: 0.25rem;
    padding: 0.5rem 1.5rem;
    color: white;
    background: var(--looks-secondary);
    font-weight: bold;
    font-size: .875rem;
    cursor: pointer;
}

.telemetry-modal_button-row_pc6a2 button:hover {
    background: var(--extensions-primary);
    box-shadow: 0 0 0 6px var(--looks-transparent);
}

.telemetry-modal_button-row_pc6a2 button:disabled {
    background: var(--text-primary);
    border-color: var(--ui-black-transparent);
    box-shadow: none;
    opacity: 0.25;
}

@media screen and (max-height: 660px) {
    .telemetry-modal_modal-content_vTkMr {
        margin: 5vh auto;
        width: 90%;
    }
}

@media screen and (max-height: 540px) {
    .telemetry-modal_illustration_ZM4Wu {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/telemetry-modal/telemetry-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,2DAA2D;AAC/D;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D,qBAAqB;;AAErB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gDAAgD;IAChD,UAAU;IACV,qBAAqB;IACrB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,YAAY;;IAEZ,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,wCAAwC;IACxC,yDAAqD;IACrD,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA,yDAAyD;;AAEzD;IACI,cAAc;IACd,cAAc;IACd,0BAA0B;IAC1B,qCAAqC;IACrC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;IAEI,2CAA2C;AAC/C;;AAEA;IACI,wBAAwB;IACxB,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wBAAwB;OACrB,qBAAqB;YAChB,gBAAgB;IACxB,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;;IAEI,+CAA+C;IAC/C,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA,oDAAoD;;AAEpD;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,qBAAqB;;IAErB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,IAAI,UAAU;IACd,MAAM,UAAU;AACpB;;AAEA;IACI,qDAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,wCAAwC;IACxC,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,8CAA8C;AAClD;;AAEA;IACI,+BAA+B;IAC/B,yCAAyC;IACzC,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\nbody {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\nh2 {\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\np {\n    font-size: 1rem;\n    line-height: 1.5em;\n}\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n/* from scratch-www */\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 510;\n    background-color: var(--ui-modal-overlay);\n}\n\n.modal-content {\n    margin: 100px auto;\n    outline: none;\n    border: .25rem solid var(--ui-white-transparent);\n    padding: 0;\n    border-radius: 0.5rem;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    width: 640px;\n\n    color: var(--text-primary);\n    overflow: hidden;\n}\n\n.illustration {\n    width: 100%;\n    height: 123px;\n    background-color: var(--looks-secondary);\n    background-image: url('./telemetry-modal-header.png');\n    background-size: cover;\n}\n\n.body {\n    background: var(--ui-white);\n    padding: 1.5rem 2.25rem;\n}\n\n.privacy-policy-link {\n    color: var(--looks-secondary);\n    text-decoration: none;\n}\n\n/* stack the radio buttons vertically, not horizontally */\n\n.radio-buttons label {\n    display: block;\n    margin: 0.5rem;\n    transition: all .125s ease;\n    background-color: hsla(0, 0%, 95%, 1);\n    border-radius: .5rem;\n    margin: 0 auto 0.375rem;\n    align-items: center;\n    padding: 1rem 0;\n    vertical-align: middle;\n}\n\n.radio-buttons label:hover {\n    background-color: hsla(215, 100%, 65%, .1);\n}\n\n.radio-buttons label.label-selected,\n.radio-buttons label.label-selected:hover {\n    background-color: hsla(215, 100%, 65%, .25);\n}\n\n.radio-buttons input[type=\"radio\"] {\n    margin: -1px 0.75rem 1px;\n    border: 1px solid hsla(0, 0%, 0%, .1);\n    border-radius: 50%;\n    width: 1rem;\n    height: 1rem;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    background-color: var(--ui-white);\n    vertical-align: middle;\n}\n\n.radio-buttons input[type=\"radio\"]:checked,\n.radio-buttons input[type=\"radio\"]:focus {\n    box-shadow: 0 0 0 2px hsla(215, 100%, 65%, .25);\n    outline: none;\n}\n\n.radio-buttons input[type=\"radio\"]:checked {\n    transition: all .25s ease;\n    background-color: var(--ui-white);\n    border: 1px solid var(--looks-secondary);\n}\n\n.radio-buttons input[type=\"radio\"]:checked::after {\n    display: block;\n    margin: 0.125rem;\n    border-radius: 50%;\n    background-color: var(--looks-secondary);\n    width: .625rem;\n    height: .625rem;\n    content: \"\";\n}\n\n/* Confirmation buttons at the bottom of the modal */\n\n.button-row {\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: baseline;\n\n    margin: 1.5rem 0;\n    font-weight: bolder;\n}\n\n@keyframes fade-out {\n    0% {opacity: 1}\n    100% {opacity: 0}\n}\n\n.setting-was-updated {\n    animation: fade-out 3s ease-out;\n    color: var(--extensions-primary);\n}\n\n.button-row button {\n    border: 1px solid var(--looks-secondary);\n    border-radius: 0.25rem;\n    padding: 0.5rem 1.5rem;\n    color: white;\n    background: var(--looks-secondary);\n    font-weight: bold;\n    font-size: .875rem;\n    cursor: pointer;\n}\n\n.button-row button:hover {\n    background: var(--extensions-primary);\n    box-shadow: 0 0 0 6px var(--looks-transparent);\n}\n\n.button-row button:disabled {\n    background: var(--text-primary);\n    border-color: var(--ui-black-transparent);\n    box-shadow: none;\n    opacity: 0.25;\n}\n\n@media screen and (max-height: 660px) {\n    .modal-content {\n        margin: 5vh auto;\n        width: 90%;\n    }\n}\n\n@media screen and (max-height: 540px) {\n    .illustration {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `telemetry-modal_modal-overlay_eJjcx`;
export { _1 as "modal-overlay" };
export var modalOverlay = `telemetry-modal_modal-overlay_eJjcx`;
var _2 = `telemetry-modal_modal-content_vTkMr`;
export { _2 as "modal-content" };
export var modalContent = `telemetry-modal_modal-content_vTkMr`;
export var illustration = `telemetry-modal_illustration_ZM4Wu`;
export var body = `telemetry-modal_body_Xq3Cm`;
var _3 = `telemetry-modal_privacy-policy-link_UYBzF`;
export { _3 as "privacy-policy-link" };
export var privacyPolicyLink = `telemetry-modal_privacy-policy-link_UYBzF`;
var _4 = `telemetry-modal_radio-buttons_WNQTW`;
export { _4 as "radio-buttons" };
export var radioButtons = `telemetry-modal_radio-buttons_WNQTW`;
var _5 = `telemetry-modal_label-selected_osqYm`;
export { _5 as "label-selected" };
export var labelSelected = `telemetry-modal_label-selected_osqYm`;
var _6 = `telemetry-modal_button-row_pc6a2`;
export { _6 as "button-row" };
export var buttonRow = `telemetry-modal_button-row_pc6a2`;
var _7 = `telemetry-modal_setting-was-updated_dQbap`;
export { _7 as "setting-was-updated" };
export var settingWasUpdated = `telemetry-modal_setting-was-updated_dQbap`;
var _8 = `telemetry-modal_fade-out_xVg3i`;
export { _8 as "fade-out" };
export var fadeOut = `telemetry-modal_fade-out_xVg3i`;
export default ___CSS_LOADER_EXPORT___;
